import type { Plugin } from '@nuxt/types';

export default (({ app }) => {
  if (!app.mixins) {
    app.mixins = [];
  }
}) as Plugin;
